import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/satellite-internet/check-availability.png'


const _hoisted_1 = { class: "si-check-availability-area pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center align-items-center g-5" }
const _hoisted_4 = {
  class: "col-lg-7 col-md-12",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "si-check-availability-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-title" }, "التحقق من التغطية", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, " تحقق من توفر الخدمة وسرعة البث في منطقتك فوراً ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, " مع سرعات سيرفراتنا العالية، يمكنك الاتصال، المشاهدة، والاستمتاع بـ البث المباشر بجودة 4K و VIP بدون تقطيع. ", -1)),
            _createElementVNode("form", {
              class: "check-form",
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.window.open('https://wa.me/447429916178', '_blank')), ["prevent"]))
            }, [...(_cache[1] || (_cache[1] = [
              _createStaticVNode("<select class=\"form-select\"><option selected>اختر نوع جهازك</option><option value=\"1\">شاشة ذكية (Smart TV)</option><option value=\"2\">جهاز أندرويد / تي في بوكس</option><option value=\"3\">هاتف ذكي / كمبيوتر</option></select><div class=\"check-btn\"><button type=\"submit\" class=\"btn\"><span class=\"border-style\">تواصل للتفعيل الفوري</span></button></div>", 2)
            ]))], 32)
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "col-lg-5 col-md-12",
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": "200"
        }, [
          _createElementVNode("div", { class: "si-check-availability-image" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "image"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}